import { useStyletron } from "baseui";
import React from "react";
import { Modal, ModalBody, ModalButton, ModalFooter, ModalHeader } from "baseui/modal";
import { Banner } from "baseui/banner";
import { useDeleteTenantMutation } from "../../../services/resourceGroups/tenantApi";
import { ICompany } from "@oqdo/automationapps/Agents/Organizations/Company";
import { useReportMutationState } from "../../../hooks/useReportMutationState";
import { FormattedMessage } from "react-intl";

interface DeleteTenantDialogProps {
  tenant: ICompany;
  isOpen: boolean;
  setIsOpen: any;
  subscriptionId: string;
}
function DeleteTenantDialog({ tenant, isOpen, setIsOpen, subscriptionId }: DeleteTenantDialogProps) {
  const [css, theme] = useStyletron();
  const [del, delResult] = useDeleteTenantMutation();
  useReportMutationState(delResult, () => setIsOpen(false));

  function close() {
    setIsOpen(false);
  }

  function deleteRg() {
    del(tenant.id);
  }

  return (
    <React.Fragment>
      <Modal onClose={close} isOpen={isOpen}>
        <ModalHeader>Delete '{tenant.name}'</ModalHeader>
        <ModalBody>
          <Banner kind="warning">You can not revert this step!</Banner>
        </ModalBody>
        <ModalFooter>
          <ModalButton kind="tertiary" onClick={close}>
            <FormattedMessage id="cancel" defaultMessage={"Cancel"} />
          </ModalButton>
          <ModalButton isLoading={delResult.isLoading} onClick={deleteRg}>
            <FormattedMessage id="ok" defaultMessage={"Okay"} />
          </ModalButton>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
}

export default DeleteTenantDialog;
